module.exports = __webpack_public_path__ + "img/pic7.0c464178.png";